export default function changeLangAttr(lan){
  document.querySelector("html").setAttribute("lang", lan);
}



// WEBPACK FOOTER //
// ./src/businessLogic/changeLangAttr.js